/**
 * @Author : ShaJiaJing
 * @Date : 2019/5/30
 * @Version : 1.0
 * @Content : 接口封装
 */

import axios from 'axios'
import qs from 'qs'
import { getSignature } from './signature'
import AES from '@/utils/aes'

function successParse (res, options) {
  // console.log(res, 'rrrr')
  return new Promise((resolve, reject) => {
    const { code, msg, result = null } = res.data
    if (code === 0 || options.isForm || options.hideCode) {
      if (options.isForm || options.hideCode) {
        resolve(res.data)
      } else {
        resolve(result)
      }
    } else {
      if (code === 210009) {
        // console.log('-------code210009：', res.data)
        reject(res.data)
      } else {
        window.$globalHub.$message.error('err: ' + msg)
        reject(msg)
      }
    }
  })
}
function errorParse (err) {
  // console.log(err, err)
  return new Promise((resolve, reject) => {
    reject(err)
  })
}
function send (url, method, body, options, baseOptions) {
  // 生成请求的url
  // url = !url.startsWith('http') ? `${DOMAIN}${url}` : url
  options = { ...options }
  baseOptions = { ...baseOptions }
  const timestamp = new Date().getTime()
  const allOpts = Object.assign({ url, method }, baseOptions, options)
  const userInfo = JSON.parse(window.$globalHub.$store.getters.userInfo || '{}')
  allOpts.headers = Object.assign(
    {
      'Accept': 'application/json',
      'Content-Type': options.isForm ? 'application/x-www-form-urlencoded' : 'application/json',
      'tenantNo': userInfo.tenantNo,
      'userName': userInfo.username,
      // 'userAlias': userInfo.custAlias,
      'userAlias': 'admin',
      'accesstoken': AES.Decrypt(window.$globalHub.$cookies.get('access_token')) || '',
      timestamp
    },
    { ...baseOptions.headers },
    { ...options.headers })
  allOpts.headers.signature = getSignature(body, timestamp)
  // post form-data请求将参数序列化成 form 参数
  if (options.isForm) {
    body = qs.stringify(body, { encode: false })
  }
  if ((body && method === 'get') || (body && method === 'delete')) {
    allOpts.params = body
  } else {
    allOpts.data = body
  }
  // console.log(allOpts, 'all')
  return axios(allOpts)
    .then((res) => successParse(res, options))
    .catch((ex) => errorParse(ex && ex.response))
}

class BaseApi {
  constructor (baseOptions) {
    this.baseOptions = baseOptions
  };
  /**
   * @param url 请求链接
   * @param body 入参
   * @param options header 头信息
   * @param defData 是否只返回出参 data 内容
   * @returns {Promise<U>|*|Promise|Promise<T>}
   */
  get (url, body, options) {
    return send(url, 'get', body, options, this.baseOptions)
  };
  delete (url, body, options) {
    return send(url, 'delete', body, options, this.baseOptions)
  };
  post (url, body, options) {
    return send(url, 'post', body, options, this.baseOptions)
  };
  put (url, body, options) {
    return send(url, 'put', body, options, this.baseOptions)
  };
}

export default BaseApi
